export const squadMembers = [
  {
    id: 'm-1',
    name: '前排橘子',
    role: '前排蹲点组',
    focus: '见面会 / 开机仪式',
    note: '习惯提前两小时到，包里永远备着折叠椅和保温杯。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20illustrated%20portrait%20of%20a%20young%20person%20with%20round%20glasses%20and%20a%20warm%20scarf%2C%20soft%20amber%20and%20cream%20background%2C%20flat%20editorial%20illustration%20style%2C%20gentle%20texture&width=400&height=400&seq=511-member-01&orientation=squarish',
  },
  {
    id: 'm-2',
    name: '外场阿吉',
    role: '外场机动组',
    focus: '音乐节 / 漫展',
    note: '负责散场后的人流观察，擅长在地图上标出接驳车排队点。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20illustrated%20portrait%20of%20a%20cheerful%20person%20wearing%20a%20canvas%20cap%20and%20backpack%2C%20soft%20terracotta%20and%20cream%20background%2C%20flat%20editorial%20illustration%20style%2C%20gentle%20texture&width=400&height=400&seq=511-member-02&orientation=squarish',
  },
  {
    id: 'm-3',
    name: '热榜小满',
    role: '热榜观察组',
    focus: '热榜脉络 / 新梗',
    note: '每天早中晚各刷一遍榜，专门负责把零散话题串成一条线。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20illustrated%20portrait%20of%20a%20calm%20person%20with%20short%20hair%20and%20headphones%2C%20soft%20amber%20and%20peach%20background%2C%20flat%20editorial%20illustration%20style%2C%20gentle%20texture&width=400&height=400&seq=511-member-03&orientation=squarish',
  },
  {
    id: 'm-4',
    name: '蹲点老周',
    role: '蹲点记录组',
    focus: '展映 / 幕后花絮',
    note: '话不多，但记录本上永远写得最细，连风大不大都记。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20illustrated%20portrait%20of%20a%20thoughtful%20older%20person%20with%20a%20notebook%20and%20pen%2C%20soft%20ochre%20and%20cream%20background%2C%20flat%20editorial%20illustration%20style%2C%20gentle%20texture&width=400&height=400&seq=511-member-04&orientation=squarish',
  },
];

export const squadRecords = [
  {
    id: 'r-1',
    time: '09-10 18:40',
    place: '综艺收官夜 · 场馆外',
    title: '散场通道提前十分钟开放',
    text: '比公告时间早了十分钟，第一批观众顺着指引有序离场，没有出现拥挤。',
    tone: '现场',
  },
  {
    id: 'r-2',
    time: '09-08 07:05',
    place: '创作者大会 · 东门',
    title: '最早的排队者已经就位',
    text: '围栏边聚了十几人，折叠椅、保温杯一应俱全，队伍安静且自觉。',
    tone: '蹲点',
  },
  {
    id: 'r-3',
    time: '09-06 20:15',
    place: '城市音乐节 · 主舞台',
    title: '副歌部分全场灯牌同步亮起',
    text: '节拍几乎一致，散场后草地保持得很干净，值得记一笔。',
    tone: '现场',
  },
  {
    id: 'r-4',
    time: '09-04 10:30',
    place: '新剧开机 · 签到处',
    title: '背景板三次调整后定型',
    text: '工作人员对画面效果比较在意，风向变化后现场很快加了配重。',
    tone: '细节',
  },
  {
    id: 'r-5',
    time: '08-30 21:00',
    place: '见面会 · 寄存处',
    title: '散场寄存处排队明显',
    text: '提前寄存大包能省下不少时间，这条经验在群里被反复转发。',
    tone: '经验',
  },
];